import { Trans, useLingui } from '@lingui/react/macro';

import { FilterCheckboxItem } from '@/design_system/Filters/FiltersMenu/FilterCheckboxItem';
import {
  FilterItem,
  FiltersMenu,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersMenu/FiltersMenu';
import { FilterTag } from '@/design_system/Filters/FiltersMenu/FilterTag';
import IconTask from '@/icons/Task.svg';
import { ARTICLE_TASK_TYPES } from '@/models/article';

import { useFilters } from '../FiltersState';
import { useTaskOptions } from '../utils';

export const FiltersTask = ({ tag }: { tag?: boolean }) => {
  const { t, i18n } = useLingui();

  const {
    tasks: { tasks, setTasks },
  } = useFilters();

  const taskOptions = useTaskOptions();

  const options =
    taskOptions.length > 0
      ? taskOptions.map(({ id, label }) => (
          <FilterCheckboxItem
            key={id}
            checked={tasks.includes(id)}
            onChange={(checked) => {
              if (checked) {
                setTasks([...tasks, id]);
              } else {
                setTasks(tasks.filter((task) => task !== id));
              }
            }}
          >
            {i18n._(label)}
          </FilterCheckboxItem>
        ))
      : [
          <FilterItem key="empty-desktop" empty>
            <Trans id="input-select.no-results">No results</Trans>
          </FilterItem>,
        ];

  if (tag) {
    if (tasks.length === 0) {
      return null;
    }

    return (
      <FiltersMenu
        button={
          <FilterTag
            label={t({ id: 'requests.filters.task.label', message: 'Task' })}
            value={
              tasks.length === 1 ? (
                i18n._(ARTICLE_TASK_TYPES.find((task) => task.id === tasks[0])!.label)
              ) : (
                <Trans id="requests.filters.task.multiple">{tasks.length} tasks</Trans>
              )
            }
            tooltip={
              tasks.length > 1
                ? tasks
                    .map((task) => i18n._(ARTICLE_TASK_TYPES.find((t) => t.id === task)!.label))
                    .join(', ')
                : undefined
            }
            onClear={() => setTasks([])}
          />
        }
      >
        {options}
      </FiltersMenu>
    );
  }

  return (
    <FiltersSubMenu
      icon={<IconTask />}
      label={t({ id: 'requests.filters.task.label', message: 'Task' })}
    >
      {options}
    </FiltersSubMenu>
  );
};
